import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect, ReactReduxContext} from 'react-redux';
import {requestAddress} from '../../actions/smartystreets';
import PrequalGeosuggest from '../PrequalGeosuggest';
import { Field, reduxForm, SubmissionError, getFormSyncErrors, getFormMeta } from 'redux-form';
import ReduxFormIsomorphic from '../../redux-form-isomorphic';
import {compose} from 'redux';

import { requestPrequal } from '../../actions/prequal';



class PrequalForm 
    extends Component
{

    componentWillMount() {
        const reduxFormIsomorphic = new ReduxFormIsomorphic(this.context.store, {
            PrequalForm: ['street', 'zip', 'secondary', 'service_type', 'coupon_code']
        });
        reduxFormIsomorphic.rehydrate();

        // @TODO find somewhere better for this to be
        // helps set focus when hydrating form
        const form = document.querySelector(`form[name=PrequalForm]`);
        if (!form) return null;
        const focused = form.querySelector(`*:focus`);
        if(!focused) return null;
        // note that setState doesn't do recursive merge
        this.setState({
            focused: focused.name
        })
    }

    render() {
        const { handleSubmit, pristine, reset, submitting, dispatch, layout, address, formSyncErrors, formMeta } = this.props;
        let focused = this.state && this.state.focused;

        return (
            <div className="prequal">
            <form onSubmit={handleSubmit} method="post" action="/">
                <h2 className="prequal__header">
                    {layout.prequal__header}
                </h2>
                <div className="prequal__body">
                    <div className="street">

                        <Field
                          id="street"
                          label="Street Address"
                          component={PrequalGeosuggest}
                          name="street"
                          placeholder={layout.street__placeholder}
                          autocomplete="off"
                          aria-label="Street Address"
                          autoFocus={focused == 'street'}
                          onChange={(e) => {
                            // @TOOD can this be moved to middleware?
                            if(e && e.suggestSelect) {

                                let address_components = e.gmaps.address_components.reduce((carry, component) => {
                                    if (component.types[0] == 'locality') {
                                        carry[component.types[0]] = component.long_name;
                                    } else {
                                        carry[component.types[0]] = component.short_name;
                                    }
                                    return carry;
                                }, {});
                                dispatch(requestAddress({
                                    street: [address_components.street_number, address_components.route].join(' '),
                                    city: address_components.locality,
                                    state: address_components.administrative_area_level_1,
                                    zipcode: [
                                        address_components.postal_code, 
                                        address_components.postal_code_suffix
                                    ].filter((e) => (e != null))
                                    .join('-')
                                }));
                            }
                          }}
                        />
                        {
                            formMeta.street && formMeta.street.touched && !formMeta.street.active && formSyncErrors.street
                            ? <div className="street__error">{layout[formSyncErrors.street]}</div>
                            : false
                        }
                    </div>

                    <div className="zip">
                        <label htmlFor="zip"
                            className="zip__label"
                        >
                            {layout.zip__label}
                        </label>
                        <Field  
                            component={zipInput}
                            name="zip"
                            autoFocus={focused == 'zip'}
                        />
                        {
                            formMeta.zip && formMeta.zip.touched && !formMeta.zip.active && formSyncErrors.zip
                            ? <div className="zip__error">{layout[formSyncErrors.zip]}</div>
                            : false
                        }
                    </div>

                    <div className="secondary">
                        <label htmlFor="secondary"
                            className="secondary__label"
                        >
                            {layout.secondary__label}
                        </label>
                        <Field 
                            component={secondaryInput}
                            name="secondary"
                            autoFocus={focused == 'secondary'}
                        />
                    </div>

                    <div className="service_types">
                        <label className="service_types__label">
                            {layout.service_types__label}
                        </label>
                        <div className="service_types__list">
                            <div className="service_type">
                                <Field 
                                    type="radio"
                                    component="input"
                                    className="service_type__input"
                                    name="service_type"
                                    value="residential"
                                    id="home"

                                />
                                <label htmlFor="home"
                                    className="service_type__label"
                                >
                                    {layout.service_type_residential__label}
                                </label>
                            </div>
                            <div className="service_type">
                                <Field 
                                    type="radio"
                                    component="input"
                                    name="service_type"
                                    className="service_type__input"
                                    value="business"
                                    title={layout.service_type_business__title}
                                    id="business"
                                />
                                <label htmlFor="business"
                                    className="service_type__label"
                                >
                                    {layout.service_type_business__label}
                                </label>
                            </div>
                        </div>
                    </div>
                    <input type="hidden" name="coupon_code" />
                    <input type="hidden" name="extra_data" id="extra_data" />
                </div>

                {address.verification_status != 'UNVERIFIED' || address.verification_status == 'ERROR'
                    ? false 
                    : <div className="prequal__error">
                    <p>{layout.address_not_recognized}</p>
                    </div>
                }

                {address.verification_status != 'ERROR'
                    ? false
                    : <div className="prequal__error text-danger">
                        <p>{layout.address_verification_error}</p>
                    </div>
                }

                <div className="prequal__footer">
                    <div className="prequalsubmit">
                        <button 
                            type="submit"
                            disabled={submitting}
                            className="prequalsubmit__button"
                        >
                            {layout.prequalsubmit__button}
                        </button>
                    </div>
                </div>

                <div className={"modal_backdrop"+(layout.is_secondary_modal_visible ? " modal_backdrop--visible" : "")}>
                    <div className={"secondary_modal"}>
                        <h2 className="secondary_modal__header">
                            {layout.secondary_modal__header}
                        </h2>
                        <div className="secondary_modal__body">
                            <p className="secondary_modal__description">
                                {layout.secondary_modal__description}
                            </p>
                            <div className="secondary2">
                                <label htmlFor="secondary2"
                                    className="secondary2__label"
                                >
                                    {layout.secondary2__label}
                                </label>
                                <Field 
                                    type="text"
                                    component="input"
                                    className="secondary2__input"
                                    name="secondary"
                                    placeholder={layout.secondary2__placeholder}
                                    id="secondary2"
                                    autoFocus={focused == 'secondary'}
                                />
                            </div>
                        </div>
                        <div className="secondary_modal__footer">
                            <div className="secondarysubmit">
                                <button 
                                    type="submit"
                                    disabled={submitting}
                                    className="secondarysubmit__button"
                                >
                                    {layout.secondarysubmit__button}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            
            </form>
            </div>
        );
    }
};
PrequalForm.contextType = ReactReduxContext;

const validate = values => {
    const errors = {};

    if(!values.street) {
        errors.street = 'street_required';
    }

    if(!values.zip) {
        errors.zip = 'zip_required';
    }

    return errors;
};

// https://github.com/erikras/redux-form/issues/2509#issuecomment-370843117
const onSubmit = (values, dispatch, props) => {
    return new Promise((resolve, reject) => {
        dispatch(requestPrequal(
            // which form we're submitting
            props.form,
            // the values
            {
                ...props.address, 
                service_type: values.service_type,
                coupon_code: values.coupon_code,
                is_secondary_modal_visible: props.layout.is_secondary_modal_visible
            },
            // methods to resolve or reject the promise
            { 
                resolve, 
                reject 
            }
        ));

    });
};

//custom input components are needed to pass into the redux Field component
//this will allow us to include an aria-label for WCAG compliance
const zipInput = (field) => (
    <div className="input-row">
        <input {...field.input} 
            type="text" 
            className="zip__input" 
            placeholder="Zip Code" 
            aria-label="Zip Code"
            id="zip"
        />
    </div>
)

const secondaryInput = (field) => (
    <div className="input-row">
        <input {...field.input} 
            type="text" 
            className="secondary__input" 
            placeholder="Apt or Suite #" 
            aria-label="Unit Number"
            id="secondary"
        />
    </div>
  )
PrequalForm = compose(
    connect((state, props) => ({
        ...props,
        layout: state.layout,
        address: state.address,
        formSyncErrors: getFormSyncErrors('PrequalForm')(state),
        formMeta: getFormMeta('PrequalForm')(state)
    })),
    reduxForm({
        validate,
        onSubmit,
        form: 'PrequalForm',
            initialValues: {
            service_type: "residential"
        }
    })
)(PrequalForm);

export default PrequalForm;


// WEBPACK FOOTER //
// ./src/components/PrequalForm/index.js